module.exports = __webpack_public_path__ + "media/images/ADDress_logo_icon_white-220fb087536b5e72bece91399bc857b6.png";